import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Menu } from 'app/shared/models/Menus/menus';
import { DataService } from 'app/shared/services/data/data.service';
import { UserService } from 'app/shared/services/user/user.service';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss']
})
export class IconComponent implements OnInit {

  @Input() menu: Menu[];
  @Input() itemMenu: Menu;
  @Input() inMyMenu: boolean;
  @Input() confirm: boolean;
  @Input() isNotUpdate: string;
  @Input() visibility: string;

  @Output() newMenu = new EventEmitter<any>();

  src: string;

  whiteOrBlue = true;

  updateItem: any;

  constructor(
    private dataService: DataService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
  }

  isSelected(): void {
    this.whiteOrBlue = !this.whiteOrBlue;
  }

  isInMyMenu(e): void {
    setTimeout(() => {
      this.dataService.isConfirmUpdate.next(true);

      this.updateItem = {
        description: this.itemMenu.description,
        login: this.itemMenu.login,
        lien: this.itemMenu.lien,
        svg_Blue: this.itemMenu.svg_Blue,
        svg_White: this.itemMenu.svg_White,
        title_Drawer: this.itemMenu.title_Drawer,
        title_Home: this.itemMenu.title_Home,
        visibilityFlag: this.inMyMenu,
        visibity: this.itemMenu.visibility,
        regroupementFlag: this.itemMenu.regroupementFlag
      };
      this.menu.forEach((el, index) => {
        if (el.title_Drawer === this.updateItem.title_Drawer) {
          this.menu[index] = this.updateItem;
          // setTimeout(() => {
          //   console.log(this.menu);
          // }, 300);

        }
      });
      this.newMenu.emit(this.menu);
    }, 200);

  }

}
